import * as yup from 'yup';
import { hasZahnSelected } from '@/features/Sparten/pkv/formConfigs/sharedRenderConditions';

export const zahnOptionenSchema = yup.object({
  leistung: yup.string().default(''),
  zahnbehandlungMin: yup
    .number()
    .min(0)
    .max(100)
    .default(100)
    .when({
      is: () => hasZahnSelected(),
      then: yup.number().required(),
    }),
  zahnersatzMin: yup
    .number()
    .min(0)
    .max(100)
    .default(70)
    .when({
      is: () => hasZahnSelected(),
      then: yup.number().required(),
    }),
  kieferorthopaedieMin: yup
    .number()
    .min(0)
    .max(100)
    .default(70)
    .when({
      is: () => hasZahnSelected(),
      then: yup.number().required(),
    }),
  materialLaborKosten: yup
    .number()
    .min(0)
    .max(100)
    .default(70)
    .when({
      is: () => hasZahnSelected(),
      then: yup.number().required(),
    }),
  gebuehrenordnung: yup.string().default(''),
  zahnSummenbegrenzungUnfall: yup.boolean().default(false),
  bruecken: yup.boolean().default(false),
  funktionsanalyse: yup.boolean().default(false),
  funktionstherapie: yup.boolean().default(false),
  implantate: yup.boolean().default(false),
  inlays: yup.boolean().default(false),
  knochenaufbau: yup.boolean().default(false),
  kronen: yup.boolean().default(false),
  kunststofffuellungen: yup.boolean().default(false),
  onlays: yup.boolean().default(false),
  parodontosebehandlung: yup.boolean().default(false),
  zahnreinigung: yup.boolean().default(false),
  veneers: yup.boolean().default(false),
  verblendungen: yup.boolean().default(false),
  wurzelbehandlung: yup.boolean().default(false),
  kieferorthopaedie: yup.boolean().default(false),
  zahnersatz: yup.boolean().default(false),
  zahnbehandlung: yup.boolean().default(false),
});
